import React from 'react';
import TeamMember from './TeamMember';
import { AboutTeamData } from '../../Data/AboutTeamData';
import Heading from '../Headers/Heading';

function TeamSection() {
    return (
        <>
            <div className="team">
                <div className="team-wrapper">
                    <Heading 
                        heading={<h6>Our team</h6>}
                        headingClass="heading-large dark-1"
                        paragraph="We work at the overlap of disciplines, where collaboration defines the result."
                        paragraphClass="dark-2"
                        WrapperComponent={(props) => {
                            return (
                                <div className="team-header">
                                    <div className="container">
                                        {props.children}
                                    </div>
                                </div>
                            )
                        }}
                    />
                    <div className="team-content">
                        <div className="container">
                            <div className="row">
                                {AboutTeamData.map((item, index) => (
                                    <TeamMember
                                        key={index}
                                        name={item.name}
                                        designation={item.designation}
                                        image={item.image}
                                        hover={item.hover} 
                                        social={item.social}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TeamSection;
